export default __webpack_public_path__ + "static/media/vip5.0b016ad0.webp";